<template>
  <v-col>
    <points-table
      :customers="records"
      :headers="headers"
      @refresh="getRecords"
    >Manage Deleted Records</points-table>
  </v-col>
</template>
<script>
import { mapActions } from "vuex";
import pointsTable from "@/components/qantas/points-table";
export default {
  name: "ManageQantasPoints",
  components: {
    pointsTable
  },
  data() {
    return {
      pagination: {
        rowsPerPage: 10,
        descending: false
      },
      records: [],
      headers: [
        {
          text: "CSN",
          value: "csn",
          align: "left",
          sortable: true,
          class: ["strong"]
        },
        {
          text: "Customer Number",
          value: "customerNo",
          align: "left",
          sortable: true,
          class: ["strong"]
        },
        {
          text: "Date Suppressed",
          value: "dateSuppressed",
          align: "left",
          sortable: true,
          class: ["strong"]
        }
      ]
    };
  },
  mounted() {
    let vm = this;
    vm.getRecords();
  },
  methods: {
    ...mapActions("qantas", ["GetDeletedRecords"]),
    getRecords() {
      let vm = this;
      vm.GetDeletedRecords().then(data => {
        vm.records = data;
      });
    }
  }
};
</script>